/**
 *! Country supported by ClickIPP and their corresponding locales
 * This mapping is based on the countries listed in the ClickIPP documentation and their associated
 * locales.
 * It serves as a reference for determining the appropriate locale to use based on the country.
 * The getLocaleFromCountry function utilizes this mapping to return the correct locale for a given
 * country.
 * If the country is not found in the mapping, it defaults to 'en-US'.
 */
const COUNTRY_LOCALE_MAP = {
  uk: 'en-GB',
  'canada-english': 'en-CA',
  'canada-french': 'fr-CA',
  mexico: 'es-MX',
  japan: 'ja-JP',
  singapore: 'en-SG',
  hongkong: 'en-HK',
  'hongkong-chinese': 'ch-HK',
  australia: 'en-AU',
  germany: 'de-DE',
  italy: 'it-IT',
  austria: 'de-AT',
  france: 'fr-FR',
  netherlands: 'nl-NL',
  newzealand: 'en-NZ',
  spain: 'es-ES',
  us: 'en-US',
  india: 'en-IN',
  sweden: 'sv-SE',
  taiwan: 'zh-TW',
  'thailand-en': 'en-TH',
  'thailand-th': 'th-TH',
  argentina: 'es-AR',
  belgium: 'fr-BE',
  'belgium-dutch': 'nl-BE'
};

// const EXTRA_COUNTRIES = {
//   apaidc: 'apaidc',
//   'australia-dj': 'en-AU',
//   brazil: 'es-BR',
//   'idc-en': 'idc-en', // Navbar
//   'idc-sp': 'idc-sp',
//   'iec-en': 'iec-en', // navbar
//   // indonesia: 'en-ID',
//   malaysia: 'en-MY',
//   philippines: 'en-PH',
// };

export const COUNTRY_SIDE_NAV = ['australia', 'uk', 'canada-english', 'canada-french', 'mexico', 'italy'];

// for Skipping the preference page
export const SKIP_PREFERENCE_LOCALES = ['en-US', 'fr-BE', 'nl-BE'];

/**
 * Default fallback locale
 */
export const DEFAULT_LOCALE = 'en-US';

/**
 * Get locale from country string
 * @param {string} country
 * @returns {string} locale
 */
export const getLocaleFromCountry = country => {
  if (!country || typeof country !== 'string') {
    return DEFAULT_LOCALE;
  }
  const normalizedCountry = country.toLowerCase();
  return COUNTRY_LOCALE_MAP[normalizedCountry] || DEFAULT_LOCALE;
};
export const GLOBAL_PREF_CODE = 'MKTGBEML';

/**
 * Validate if country exists in the configured map.
 * @param {string} country
 * @returns {boolean}
 */
export const isSupportedCountry = country => {
  if (!country || typeof country !== 'string') {
    return false;
  }
  return Object.prototype.hasOwnProperty.call(COUNTRY_LOCALE_MAP, country.toLowerCase());
};

/**
 * Validate if locale file exists (optional safety helper)
 */
export const isSupportedLocale = locale => Object.values(COUNTRY_LOCALE_MAP).includes(locale);

/**
 * Extract country from privacy pathname (/privacy/:country)
 * @param {string} pathname
 * @returns {string}
 */
export const getCountryFromPrivacyPathname = (pathname = '') => {
  if (!pathname || typeof pathname !== 'string') {
    return '';
  }
  const [, modulePath, country] = pathname.toLowerCase().split('/');
  if (modulePath !== 'privacy') {
    return '';
  }
  return country || '';
};

/**
 * Check if the current pathname is a privacy market that supports side nav
 * @param {string} pathname
 * @returns {boolean}
 */
export const isSideNavMarketPathname = (pathname = '') => COUNTRY_SIDE_NAV.includes(getCountryFromPrivacyPathname(pathname));
export const validateEmailRegex = value => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};
export const APP_MODULE_NAME = 'axp-digital-identity-unsubscribe';
export function isUkMarketPathname(pathname = '') {
  return getCountryFromPrivacyPathname(pathname) === 'uk';
}
export function shouldSkipPreferencePageByLocale(locale) {
  return SKIP_PREFERENCE_LOCALES.includes(locale);
}
export function isUsMarketPathname(activeLocale) {
  return activeLocale === 'en-us' || activeLocale === 'en_us';
}
export function isMexicoMarketPathname(activeLocale) {
  return activeLocale === 'es-mx' || activeLocale === 'es_mx';
}
export function isTaiwanMarketPathname(activeLocale) {
  return activeLocale === 'zh-tw' || activeLocale === 'zh_tw';
}
export function correlationIdGenerator() {
  return `DIGUNSUB_${Date.now()}`;
}